VLW.Compenents.BtnCarteVin = class extends VLW.Compenents.IntersectionObjserver {
	constructor(elt) {
		super(elt);
		TweenMax.set(this.elt, {opacity: 0});
	}
	onIntersectionVisible() {
		window.promiseIntro.then(()=> {
			super.onIntersectionVisible();
			TweenMax.to(this.elt, 1, {opacity: 1, ease: Sine.easeIn});
		});
	}
};


